import React, { FC, useRef, useState } from "react";
import AE2Modal from "../../elements/AE2Modal";
import { IonButton, IonDatetime, IonDatetimeButton, IonIcon, IonInput, IonItem, IonList, IonModal, IonRadio, IonRadioGroup, IonSelect, IonSelectOption, IonSpinner, IonText, IonToggle } from "@ionic/react";
import { cloudUploadOutline,} from "ionicons/icons";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import "./UploadIntervalDataBtn.css"


interface IProps {
    id: String
};

async function upload_csv(data:any,token:string,endpoint:string) {
    return fetch(`${API_URL}/interval_data/${endpoint}`, {
        method: 'POST',
        headers: {
            'Accept': "application/json",          
            'Authorization':token
        },
        body: data

      })
        .then((res) => {
            if (res.ok) {
            return res.json();
            } else {
                res.json().then( err => {
                    console.log(err)
                NotificationPopUp("Error", err.error, "Error Uploading CSV")                
            })
            return false;
            }
        });
     }

const UploadIntervalDataBtn:FC<IProps> = (props) => {
    const [opened, setOpened] = useState(false)
    const fileInput = useRef<HTMLInputElement>(null);
    const fileDate = useRef<null | HTMLIonDatetimeElement>(null);
    const [filename, setFilename] = useState('No File Selected')
    const [singleDay, setSingleDay] = useState(false)
    const [units, setUnits] = useState('')
    const [unitsInput, setUnitsInput] = useState<any>('')
    const [uploading, setUploading] = useState(false)
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploadType, setUploadType] = useState('data');


    const handleFileSelected = (e:any) => {
        console.log(e)
        const file: File = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFilename(file.name);
        }
    }

    const handleUpload = async () =>{        
        if (!selectedFile) return;
        const formData = new FormData()
        formData.append('file',selectedFile)

      
        const selectedUnits = units === 'Other' ? unitsInput : units;
        if (!selectedUnits) return;
        setUploading(true);

        formData.append('id',String(props.id))
        formData.append('units',selectedUnits)
        formData.append('date',fileDate.current?.value?.toString()||'')
        let endpoint = 'upload'
        if(uploadType === 'model_data'){
            endpoint = 'upload_model'
        }
        
        const tkn: any = localStorage.getItem("token");
        const token = `Token ${tkn.slice(1, -1)}`;
        const res = await upload_csv(formData, token,endpoint);
        
        if(res['status'] === 'success'){
            NotificationPopUp("success","CSV file processed and uploaded", "Interval Data Saved")
            setOpened(false)
        }
        setUploading(false);
   
    }

    return <div>
            <IonButton onClick={()=>setOpened(true)} fill='clear' color={'light'}>
                <IonIcon src={cloudUploadOutline}/>
            </IonButton>
            <AE2Modal title="Upload Interval Data" opened={opened} setOpened={setOpened} style={{'--max-height':'35%'}}>
                <div style={{width:'100%', textAlign:'center'}}>
                    <div style={{margin:'1rem'}}>
                        <IonRadioGroup className="chip-radio" value={uploadType} onIonChange={(e)=>setUploadType(e.detail.value)}>
                            <IonRadio className="chip-radio" value='data'>Data</IonRadio>
                            <IonRadio className="chip-radio" value='model_data'>Model</IonRadio>
                        </IonRadioGroup>
                        <div style={{margin:'0.3rem'}}><a href={ uploadType === 'model_data' ? "/templates/Model_Interval_Data_TEMPLATE.csv" : "/templates/Interval_Data_TEMPLATE.csv"}> Download Template</a></div>
                    </div>
                    <div style={{display:'flex', alignItems:'center', backgroundColor:'white', borderRadius:'1rem', padding:'0.3rem'}}>
                        <span style={{color:'black',width:'75%',}}>
                            {filename}
                        </span>
                        <IonButton onClick={()=>fileInput.current?.click()}>Select File</IonButton>                    
                    </div>
                    <input ref={fileInput} onChange={handleFileSelected} type='file' accept=".csv" hidden/>

                    <div style={{display:'flex',color:'white', marginTop:'0.5rem', justifyContent:'space-between'}}>
                        <div style={{alignItems:'center', fontSize:'1.3rem'}} hidden={uploadType==='model_data'}>
                            <IonToggle checked={singleDay} onIonChange={(e)=>{setSingleDay(e.detail.checked)}}>Single Day</IonToggle>
                        </div>
                        <div hidden={!singleDay}>
                            {/* {''} */}
                            <IonDatetimeButton datetime="file_date"></IonDatetimeButton>
                            <IonModal keepContentsMounted={true}>
                                <IonDatetime
                                  ref={fileDate}
                                  id="file_date"
                                  presentation="date"
                                ></IonDatetime>
                            </IonModal>
                        </div>                        
                    </div>
                    <div style={{padding:'1rem'}}>
                        <IonList style={{borderRadius:'1rem'}}>
                            <IonItem>
                                <IonSelect value={units} onIonChange={e=>setUnits(e.detail.value)} interface="popover">
                                    <div slot="label" style={{color:'black'}}>
                                        Units <IonText hidden={units !== ''} color="danger">(Required)</IonText>
                                    </div>
                                    <IonSelectOption value='kW'>kW</IonSelectOption>
                                    <IonSelectOption value='kWh'>kWh</IonSelectOption>
                                    <IonSelectOption value='therms'>therms</IonSelectOption>
                                    <IonSelectOption value="Other">Other</IonSelectOption>
                                </IonSelect>
                            </IonItem>
                            <IonItem hidden={units!=='Other'}>
                                <IonInput value={unitsInput} labelPlacement="stacked"  onIonInput={e=>setUnitsInput(e.detail.value)}>
                                    <div slot="label" style={{color:'black'}}>
                                        Enter Units <IonText hidden={unitsInput !== ''} color="danger">(Required)</IonText>
                                    </div>
                                </IonInput>
                            </IonItem>
                        </IonList>
                    </div>
                    <div>
                        <IonButton shape="round" disabled={uploading} onClick={()=>handleUpload()}>
                            {
                                uploading ? <IonSpinner/> : "Upload"
                            }
                        </IonButton>
                    </div>
                </div>
            </AE2Modal>
    </div>
};

export default UploadIntervalDataBtn;